import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Http from "../../Http";
import { Loan_API } from "../../Helper";

import { motion } from "framer-motion";
import {
  FaMoneyCheckAlt,
  FaShieldAlt,
  FaHeart,
  FaBriefcaseMedical,
  FaPlane,
  FaBalanceScale,
  FaUserShield,
  FaGift,
  FaCalendarAlt,
  FaCalculator,
  FaFileInvoiceDollar,
  FaLockOpen,
  FaStar,
  FaRocket,
  FaExclamationTriangle,
  FaExchangeAlt,
} from "react-icons/fa";
import {
  FaHome,
  FaUser,
  FaBriefcase,
  FaMoneyBillWave,
  FaCalendarCheck,
  FaChartLine,
  FaFileInvoice,
  FaFlag,
} from "react-icons/fa";
import { FaRupeeSign, FaPercentage } from "react-icons/fa";
import { ArrowRight } from "lucide-react";
import FAQSchema from "../../FAQSchema";
import AdBanner from "../AdPage/AdBanner";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const PersonalLoanNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loanData, setLoanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const faqs = [
    {
      question: " What is a personal loan?",
      answer:
        "A personal loan is a type of loan where a lender provides you with a lump sum of money that you agree to repay over a set period, typically with interest. Personal loans can be used for various purposes, such as debt consolidation, home improvement, medical expenses, or travel. Unlike some other loans, personal loans are generally unsecured, meaning they do not require collateral.",
    },
    {
      question: "What factors should I consider when choosing a personal loan?",
      answer:
        "When choosing a personal loan, consider factors like the interest rate, loan term, monthly payment amount, total loan cost, and additional fees or charges. It is also important to evaluate your credit score, as it can impact the terms and interest rates you qualify for. Other factors to consider include the loan approval process, prepayment penalties, and any flexibility in repayment options.",
    },
    {
      question:
        "  Which bank offers the lowest interest rate on personal loans?",
      answer:
        "The interest rate for personal loans varies depending on factors like the loan amount, your credit score, loan tenure, and financial history. To find the best rate, compare offers from different banks and lending institutions. You can obtain personalized rates by providing your financial information to lenders and using our comparison tools to assess your best options.",
    },
    {
      question: "Can I get a personal loan through TheFinMaster.com?",
      answer:
        "  TheFinMaster.com does not offer personal loans directly. However, we provide educational resources, loan comparison tools, and unbiased information to help you understand personal loans and choose the best one for your needs. Once you have identified a suitable loan, you will be directed to the lenders website to complete a secure application process.",
    },
    {
      question:
        "What is the maximum loan amount I can get with a personal loan?",
      answer:
        "The maximum loan amount varies based on your income, credit score, and lender’s policies. Typically, personal loans range from ₹50,000 to ₹50 lakh, but some lenders may offer higher amounts for specific purposes or higher-income applicants.",
    },
    {
      question: "What is the interest rate for personal loans?",
      answer:
        "Personal loan interest rates generally range from 10% to 25%, depending on your credit profile, loan amount, and tenure. A higher credit score may help you secure a lower interest rate, making it easier to manage EMIs.",
    },
    {
      question: "What is the tenure for a personal loan?",
      answer:
        "Personal loan tenures typically range from 1 to 5 years. While longer tenures lower your EMI, they may increase the total interest paid. Choose a tenure based on your repayment capacity and financial plans.",
    },
    {
      question: "Can I apply for a personal loan without a credit score?",
      answer:
        "Having a credit score is important for personal loan approval. However, some lenders may offer loans with flexible terms to individuals with no or low credit scores, often at higher interest rates or with a guarantor.",
    },
    {
      question: "What documents are required for a personal loan application?",
      answer:
        "Common documents include proof of identity (Aadhar/PAN card), proof of income (salary slips/IT returns), address proof (utility bills), and bank statements. Some lenders may also require a credit report and employment verification.",
    },
    {
      question: "Can I apply for a personal loan if I am self-employed?",
      answer:
        "Yes, self-employed individuals can apply for personal loans. They may need to provide additional documents like business financials, income tax returns for the last 2–3 years, and bank statements to verify income and financial stability.",
    },
    {
      question: "Is personal loan approval guaranteed?",
      answer:
        "No, personal loan approval is not guaranteed. Lenders assess your creditworthiness, including your income, credit score, and existing liabilities. If any of these factors are not in your favor, the loan may be rejected.",
    },
    {
      question: "What is the processing fee for personal loans?",
      answer:
        "The processing fee for personal loans typically ranges from 1% to 3% of the loan amount. Some lenders may waive off the processing fee during special promotions, so it's essential to check the terms before applying.",
    },
    {
      question: "Can I get a personal loan for any purpose?",
      answer:
        "Yes, personal loans are versatile and can be used for various purposes, including medical expenses, education, home renovation, travel, or debt consolidation. However, it’s important to check the specific terms with the lender as some may have restrictions on the usage.",
    },
    {
      question: "Can I repay my personal loan before the due date?",
      answer:
        "Yes, most lenders allow prepayment or foreclosure of personal loans. Some lenders may charge a penalty fee for prepayment, but it can help you save on interest. It's recommended to check with the lender about the applicable prepayment charges.",
    },
    {
      question: "How does a personal loan EMI calculator work?",
      answer:
        "A personal loan EMI calculator helps estimate the monthly installment based on the loan amount, interest rate, and tenure. This tool is useful for planning your loan repayment and understanding how changes in tenure or interest rates affect your EMIs.",
    },
    {
      question: "Can I get a personal loan without a guarantor?",
      answer:
        "Yes, personal loans are generally unsecured, meaning you don’t need a guarantor or collateral. However, if you have a low credit score or a limited credit history, some lenders might require a co-applicant or guarantor.",
    },
    {
      question: "What happens if I miss a personal loan EMI payment?",
      answer:
        "Missing an EMI payment can lead to late fees, an increase in interest charges, and a negative impact on your credit score. If you miss multiple payments, the lender may report it to credit bureaus, affecting your creditworthiness.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    fetchLoanData();
  }, []);
  const fetchLoanData = async () => {
    try {
      const response = await Http.get(Loan_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.loan || response;

      // Filter the insurance data to show only Car category
      const carLoanData = Array.isArray(data)
        ? data.filter(
            (insurance) => insurance.category_name === "Personal Loan"
          )
        : [];

      setLoanData(carLoanData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch Loan data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const loanTypes = [
    {
      name: "Unsecured Personal Loan 💳",
      description:
        "This is the most common type of personal loan where no collateral is required. Lenders approve the loan based on the borrower's creditworthiness, income, and repayment capacity. These loans can be used for any purpose, such as medical emergencies, travel, or home renovation.",
      icon: <FaMoneyCheckAlt />,
    },
    {
      name: " Secured Personal Loan 🔑",
      description:
        "Unlike unsecured loans, secured personal loans require the borrower to pledge an asset (such as property, fixed deposits, or gold) as collateral. These loans offer lower interest rates due to reduced risk for lenders.",
      icon: <FaShieldAlt />,
    },
    {
      name: "Wedding Loan 💍",
      description:
        "A wedding loan is a type of personal loan specifically designed to cover wedding-related expenses, including venue booking, catering, decorations, and honeymoon trips. Given the high cost of weddings in India, many banks and NBFCs offer specialized loans for this purpose.",
      icon: <FaHeart />,
    },
    {
      name: "Medical Emergency Loan 🏥",
      description:
        "This type of personal loan provides quick access to funds for medical emergencies, such as hospital bills, surgeries, or expensive treatments. Some lenders offer instant disbursal options to cater to urgent healthcare needs.",
      icon: <FaBriefcaseMedical />,
    },
    {
      name: "Travel Loan ✈️",
      description:
        "Travel loans are tailored for financing domestic and international vacations. They cover expenses like flight tickets, hotel bookings, sightseeing, and other travel-related costs. Some banks offer exclusive travel loans with special discounts on travel packages.",
      icon: <FaPlane />,
    },
    {
      name: "Debt Consolidation Loan 🔄 ",
      description:
        "This loan helps individuals consolidate multiple debts (such as credit card bills and existing loans) into a single loan with a lower interest rate, making repayment more manageable. It is useful for individuals struggling with multiple EMI payments.",
      icon: <FaBalanceScale />,
    },
    {
      name: "Pension Loan 👴",
      description:
        "Senior citizens and pensioners can avail themselves of pension loans against their monthly pension income. Banks often provide these loans with relaxed eligibility criteria for retired individuals.",
      icon: <FaUserShield />,
    },
    {
      name: "Festival Loan 🎉",
      description:
        "Banks and NBFCs offer short-term festival loans to help individuals cover festival-related expenses such as gifts, decorations, and travel. These loans are usually offered at competitive interest rates during the festive season.",
      icon: <FaGift />,
    },
  ];

  const points = [
    {
      title: " No Collateral Required",
      description: ` Being an unsecured loan, you don’t need to pledge assets like property or a vehicle.`,
    },
    {
      title: "Quick Disbursal",
      description: ` Personal loans are processed within hours or a few days, making them ideal for urgent financial needs.`,
    },
    {
      title: "Flexible Usage ",
      description: `  Unlike home or car loans, personal loans can be used for various purposes such as weddings, travel, or medical emergencies.`,
    },
    {
      title: "Minimal Documentation ",
      description: ` Digital lending processes have simplified loan approvals with minimal paperwork.`,
    },
    {
      title: "Higher Loan Amounts ",
      description: ` Compared to credit card loans, personal loans offer larger loan amounts at relatively lower interest rates.`,
    },
  ];
  const points1 = [
    {
      title: "  Higher Interest Rates",
      description: `Personal loans have higher interest rates (10%-24%) compared to secured loans like home or car loans.`,
    },
    {
      title: " Fixed Repayment Structure ",
      description: `Unlike a credit card, you have to pay EMIs regularly for a fixed tenure.`,
    },
    {
      title: "Impact on Credit Score",
      description: ` A rejected loan application or missed EMIs can significantly impact your credit score.`,
    },
    {
      title: "Processing Fees",
      description: `Lenders charge processing fees (1-3% of the loan amount), adding to the overall cost.`,
    },
    {
      title: "Debt Trap Risk",
      description: `Borrowers who take multiple personal loans without a repayment plan may fall into a debt cycle.`,
    },
  ];

  const points3 = [
    {
      title: "Interest Rate & Total Cost of Loan",
      points: [
        " Personal loans come with varying interest rates based on your credit score, income, and lender policies. Compare interest rates from different lenders to find the lowest option. Also, consider the annual percentage rate (APR), which includes processing fees and other charges to determine the total cost of the loan.",
        "Tip: Borrowers with a credit score of 750+ usually get lower interest rates.",
      ],
    },
    {
      title: " Loan Amount & Repayment Tenure",
      points: [
        "Different lenders offer varying loan amounts, typically ranging from ₹50,000 to ₹50 lakh, depending on your eligibility. Additionally, check the repayment tenure options, which usually range between 1 to 5 years.",
        "Tip: Choose a loan amount that meets your needs but doesn’t burden you with excessive EMIs. Opt for a shorter tenure to reduce interest costs, but ensure you can manage the EMI payments comfortably.",
      ],
    },
    {
      title: "Loan Amount & Eligibility",
      points: [
        " Loan-to-Value (LTV) Ratio: Banks finance 75-90% of the property value, and you must arrange the rest as a down payment.",
        "Income & Credit Score: A higher credit score (750+) improves eligibility and helps secure better interest rates.",
        " Tip: Use a home loan eligibility calculator to estimate how much loan you can get based on your income and financial status.",
      ],
    },
    {
      title: "Eligibility Criteria & Credit Score Requirements",
      points: [
        "Most banks and NBFCs require:",
        "Employment: Salaried or self-employed",
        "Minimum monthly income: ₹15,000 - ₹25,000 (varies by lender)",
        "Credit score: 700+ for better approval chances and lower rates",

        "Tip: If you have a low credit score (<700), your loan may be approved at higher interest rates or require a co-applicant.",
      ],
    },
    {
      title: " Processing Fees & Hidden Charges",
      points: [
        "Apart from interest rates, check for processing fees, which usually range between 1% to 3% of the loan amount. Some lenders may also charge prepayment penalties, late payment fees, and foreclosure charges.",
        " Tip: Opt for lenders offering low or zero prepayment charges, so you can repay the loan early without extra costs.",
      ],
    },
    {
      title: " Loan Disbursal Time & Documentation",
      points: [
        "Personal loans are ideal for urgent financial needs, so check how quickly the lender disburses funds. Many banks and NBFCs now offer instant approval and same-day disbursal for pre-approved applicants.",
        "Tip: Opt for lenders with minimal documentation and online application processes for faster approval.",
      ],
    },
    {
      title: " Compare Lenders & Loan Offers",
      points: [
        "Different lenders provide different offers, so use loan comparison platforms to analyze interest rates, charges, and benefits. Some banks may provide special offers for existing customers with pre-approved loans at discounted rates.",
        "Tip: Compare loans from banks, NBFCs, and digital lenders to find the most affordable and flexible option.",
      ],
    },
  ];

  const reasons = [
    {
      title: "Loan Amount (Principal)",
      description:
        "The principal amount is the sum borrowed from the lender. It varies based on the borrower's income, creditworthiness, and repayment capacity. Personal loans in India typically range from ₹50,000 to ₹50 lakh, depending on the lender and borrower's profile.",
      icon: <FaRupeeSign className="text-blue-600 text-3xl" />,
    },
    {
      title: "Interest Rate",
      description:
        "The interest rate is the percentage charged by the lender on the loan amount. It can be fixed or floating and varies based on the borrower's credit score, income, and employment stability. Interest rates for personal loans in India generally range between 10% and 24% per annum.",
      icon: <FaPercentage className="text-green-600 text-3xl" />,
    },
    {
      title: "Loan Tenure",
      description:
        "The tenure is the repayment duration for the loan. Personal loans usually have a tenure between 12 months and 5 years, with some lenders offering up to 7 years. Longer tenures result in lower EMIs but higher overall interest payments.",
      icon: <FaCalendarAlt className="text-orange-600 text-3xl" />,
    },
    {
      title: "Equated Monthly Installment (EMI)",
      description:
        "EMI is the fixed amount that a borrower must pay every month towards loan repayment. It consists of both principal and interest components. The EMI amount depends on the loan amount, interest rate, and tenure.",
      icon: <FaCalculator className="text-yellow-600 text-3xl" />,
    },
    {
      title: " Processing Fees",
      description:
        "Lenders charge a one-time processing fee, typically between 1% and 4% of the loan amount, for processing the loan application. Some lenders waive this fee during special promotions.",
      icon: <FaFileInvoiceDollar className="text-purple-600 text-3xl" />,
    },
    {
      title: "Prepayment and Foreclosure Charges",
      description:
        "Borrowers can repay their loan before the tenure ends, either partially (prepayment) or fully (foreclosure). Some banks charge a 2% to 5% penalty on the outstanding amount for early repayment, while others allow it without any charges.",
      icon: <FaLockOpen className="text-red-600 text-3xl" />,
    },
    {
      title: "Credit Score Requirement",
      description:
        "A borrower's credit score plays a vital role in loan approval. A CIBIL score of 750 or above increases the chances of getting a loan at a lower interest rate. Individuals with a lower score may face higher interest rates or rejection.",
      icon: <FaStar className="text-teal-600 text-3xl" />,
    },
    {
      title: "Loan Disbursal Time",
      description:
        "Personal loans are typically processed quickly, with instant approval options available with some banks and NBFCs. The disbursal time can range from a few hours to a couple of days, depending on the lender.",
      icon: <FaRocket className="text-pink-600 text-3xl" />,
    },
    {
      title: "Late Payment Penalty",
      description:
        "If a borrower fails to pay the EMI on time, a late payment penalty is imposed. This can range between ₹500 to ₹1,000 per missed EMI or a percentage of the EMI amount.",
      icon: <FaExclamationTriangle className="text-indigo-600 text-3xl" />,
    },
    {
      title: "End-Use Flexibility",
      description:
        "Unlike home or car loans, personal loans do not have usage restrictions. They can be used for various purposes, including weddings, medical emergencies, travel, home renovation, education, or debt consolidation.",
      icon: <FaExchangeAlt className="text-gray-600 text-3xl" />,
    },
  ];

  const eligibilityCriteria = [
    {
      title: "Residential Stability",
      points: [
        "The applicant must have a permanent address or a stable rental address for at least 1 year before applying.",
      ],
      icon: <FaHome className="text-blue-500 text-2xl" />,
    },
    {
      title: "Citizenship and Residency",
      points: [
        "The applicant must be a Resident Indian, with some lenders also offering personal loans to Non-Resident Indians (NRIs) with additional conditions.",
      ],
      icon: <FaFlag className="text-green-500 text-2xl" />,
    },
    {
      title: "Age Requirement",
      points: [
        "The applicant must be between 21 to 60 years (varies by lender).",
        "Some lenders offer loans to retirees or senior citizens with a stable pension.",
      ],
      icon: <FaUser className="text-blue-500 text-2xl" />,
    },
    {
      title: "Loan Repayment Capacity",
      points: [
        "Lenders evaluate the applicant’s Debt-to-Income (DTI) ratio to ensure they can manage additional EMIs.",
        "Ideally, existing EMIs should not exceed 40-50% of monthly income.",
      ],
      icon: <FaFileInvoice className="text-orange-500 text-2xl" />,
    },

    {
      title: "Work Experience",
      points: [
        "Salaried employees should have at least 1 year of total work experience and 6 months in the current organization.",
        "Self-employed applicants must have a business operational for at least 2-3 years with stable revenue.",
      ],
      icon: <FaCalendarCheck className="text-red-500 text-2xl" />,
    },
    {
      title: "Credit Score Requirement",
      points: [
        "A credit score of 750 or above increases the chances of loan approval at a lower interest rate.",
        "Individuals with a score below 650 may face higher interest rates or loan rejection.",
      ],
      icon: <FaChartLine className="text-purple-500 text-2xl" />,
    },

    {
      title: "Employment Type",
      points: [
        "Salaried Individuals: Should be employed with a private/public sector company or government organization.",
        "Self-Employed Individuals: Business owners, freelancers, or professionals (doctors, CA, etc.) can apply based on income stability.",
      ],
      icon: <FaBriefcase className="text-green-500 text-2xl" />,
    },
    {
      title: "Minimum Monthly Income",
      points: [
        "Salaried employees typically need a minimum monthly income of ₹15,000 to ₹25,000, depending on the lender and city of residence.",
        "Self-employed individuals must show consistent income with audited financial statements.",
      ],
      icon: <FaMoneyBillWave className="text-yellow-500 text-2xl" />,
    },
  ];
  const features = [
    { icon: '👛', text: ' Instant & Accurate EMI Results' },
    { icon: '⏱️', text: 'Takes Less Than a Minute' },
    { icon: '📏', text: 'Works for Any Amount or Tenure' },
    { icon: '📄', text: 'No Form-Filling or Delays' },
    { icon: '📲', text: ' Simple, Fast & Mobile Friendly' },
    { icon: '💰', text: 'Helps Choose Smart Repayment Plan' },
  ];
  return (
    <>
      <Helmet>
        <title>
        Best Personal Loans in India – Compare Offers & Apply
        </title>
        <meta
          name="description"
          content="Compare personal loan offers from top banks & NBFCs. Get instant approval with low interest rates and minimal paperwork."
        />
        <meta
          name="keywords"
          content="personal loan rates, personal loans online, apply for personal loan, secured personal loan"
        />
        <link rel="canonical" href="https://thefinmaster.com/personal-loan" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500 ">Personal Loan</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-3xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                  <span className="text-blue-600 ">
                    Get instant Personal Loans for any need
                  </span>{" "}
                  no collateral, quick approvals, and flexible repayment terms
                </h1>
                {/* <a href="#insurance_plans">
                  <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                    See Plans
                  </button>
                </a> */}
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full mt-2"
                src="/assets/pl.png"
                alt="personal-loan"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <p className="text-lg md:text-base lg:text-lg text-center">
          TheFinMaster.com takes the stress out of finding a personal loan. Our
          platform connects you with a variety of lenders, allowing you to
          easily compare interest rates, repayment terms, and loan amounts.
          TheFinMaster.com helps you find the perfect personal loan to get back
          on track and achieve your goals.
        </p>{" "}
      </div>
      <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-3/4">
      <div id="loan_plans" className="lg:pr-6 md:px-4 px-2">
      {loading ? (
              <div className="text-center py-10">Loading Loan options...</div>
            ) : error ? (
              <div className="text-center py-10 text-red-600">{error}</div>
            ) : loanData.length === 0 ? (
              <div className="text-center py-10">
                No Personal Loan options available at the moment.
              </div>
            ) : (
          loanData.map((loan) => (
            <div
              key={loan.id}
              className="md:w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-5 justify-between mx-auto mt-4"
            >
              <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                <Link to={`/personal-loan/${loan.page_url}`}>
                  <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                    <img
                      className="w-full h-full object-contain"
                      alt={loan.page_title || "Loan Provider"}
                      src={loan.image}
                    />
                  </div>
                </Link>
              </div>

              <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                <p className="text-gray-500 font-medium">Interest Rate</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {loan.interest_rate}%
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                <p className="text-gray-500 font-medium">Loan Amount </p>
                <h4 className="text-2xl py-0.5 font-bold">
                  ₹{loan.loan_amount}
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                <p className="text-gray-500 font-medium">Processing Fee</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  ₹{loan.processing_fee}
                </h4>
              </div>

              <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                <a
                  href={loan.bank_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                    Apply Now
                  </button>
                </a>

                <Link to={`/personal-loan/${loan.page_url}`}>
                  <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                  See Details
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
</div>
<div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
          <div className="sticky top-20">
            {/* Ad 1 - Visible on all screen sizes */}
            <AdBanner displayOrder="2" />
            
            {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
            {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
            {/* Compact ad for mobile only */}
            {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>

      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            What is a Personal Loan?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A personal loan is an unsecured loan that individuals can borrow
            from banks, non-banking financial companies (NBFCs), or online
            lenders to meet various financial needs. Unlike home or car loans,
            which are tied to specific purposes, personal loans offer
            flexibility in usage, making them a preferred choice for various
            personal financial requirements.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            Since it is unsecured, a personal loan does not require collateral
            or security. Instead, lenders assess an applicant’s
            creditworthiness, income, and repayment ability before approving the
            loan.
          </p>
        </div>
      </div>
      <section className="bg-blue-50 py-6 px-4 sm:px-6 md:px-20 lg:px-20 rounded-3xl shadow-lg max-w-6xl mx-auto mt-6"> 
  <div className="flex flex-col md:flex-row justify-between items-center gap-10">
    {/* Left - Text and CTA */}
    <div className="max-w-xl space-y-6 text-center md:text-left">
      <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 leading-tight">
        Calculate Your Personal Loan <br />
        in <span className="text-blue-600">Seconds</span>
      </h2>
      <p className="text-gray-700 text-lg">
        Use our fast and free calculator to estimate your premium — no paperwork, no waiting.
      </p>
      <Link
        to="/financial-tools-calculators/personal-loan-emi-calculator"
        className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 text-lg rounded-full shadow-md transition"
      >
        Start Calculating <ArrowRight className="w-5 h-5" />
      </Link>
    </div>

    {/* Right - Feature List with Emojis */}
    <div className="space-y-4 text-left">
      {features.map((item, index) => (
        <div key={index} className="flex items-center gap-3">
          <span className="text-xl">{item.icon}</span>
          <span className="text-gray-800 font-medium">{item.text}</span>
        </div>
      ))}
    </div>
  </div>
</section>
      <div className="max-w-7xl mx-auto px-4 py-6 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Key stats of Personal Loan
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2">
          Choosing the right car insurance is crucial for financial security on
          the road. Here are the three main types of car insurance plans:
        </p> */}

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🏡</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Outstanding Personal Loan Portfolio
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              In the financial year 2022, the total outstanding balance of
              personal loans in India was approximately ₹8 trillion, marking a
              continuous increase since 2020.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📊</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Loan Growth Rate
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              As of January 2025, personal loan growth decelerated to 9.2%
              year-on-year, a significant drop from 20.8% in January 2024. This
              slowdown is attributed to tighter lending regulations imposed by
              the Reserve Bank of India (RBI) in late 2023.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💰</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Projected Market Growth
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              The Indian personal loan market is projected to grow from USD 8.34
              billion in FY2024 to USD 54.86 billion by FY2032, reflecting a
              compound annual growth rate (CAGR) of 26.55% during this period.
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center">
          Types of Personal Loans in India
        </h2>
        <p className="text-gray-700 text-base md:text-lg mt-3 text-center max-w-3xl mx-auto">
          Personal loans come in various forms to cater to different financial
          needs. Below are the major types of personal loans available in India:
        </p>

        {/* Responsive Grid Layout */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {loanTypes.map((loan, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="bg-white shadow-md border border-gray-200 rounded-xl p-6 flex flex-col"
            >
              <div className="text-3xl text-blue-500">{loan.icon}</div>
              <h3 className="text-xl font-semibold mt-3">{loan.name}</h3>
              <p className="mt-2 text-gray-600">{loan.description}</p>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">
          Key Components of a Personal Loan
        </h2>
        <p className="text-gray-700 text-base md:text-lg mt-3 text-center max-w-3xl mx-auto">
          A personal loan consists of several crucial elements that determine
          its structure, cost, and repayment terms. Understanding these
          components helps borrowers make informed financial decisions.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mt-4">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-4 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition"
            >
              <div>{reason.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  {reason.title}
                </h3>
                <p className="text-gray-600">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Eligibility Criteria Section */}
        <h2 className="text-2xl md:text-3xl font-bold text-center  mb-6">
          Eligibility Criteria for a Personal Loan
        </h2>
        <p className="text-gray-600 text-center mb-8">
          The eligibility criteria for availing a personal loan in India vary
          across lenders. However, some general requirements apply to most banks
          and financial institutions.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
          {eligibilityCriteria.map((criteria, index) => (
            <div
              key={index}
              className="p-6 bg-gray-100 shadow-md rounded-2xl hover:shadow-lg transition-all duration-300 flex items-start gap-4"
            >
              {criteria.icon}
              <div>
                <h3 className="font-semibold text-lg mb-2">{criteria.title}</h3>
                <ul className="list-disc list-inside text-gray-600 text-md">
                  {criteria.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h3 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Pros and Cons of Personal Loans
          </h3>
          <p className="text-gray-700 mb-6">✅ Pros:</p>

          {points.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h3 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Pros and Cons of Personal Loans
          </h3>
          <p className="text-gray-700 mb-6">❌ Cons</p>

          {points1.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className=" px-2 p-6 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            How to Choose the Right Personal Loan: Key Factors to Consider
          </h2>
          <p className="text-gray-700 mb-6">
            Selecting the right personal loan requires careful evaluation of
            multiple factors to ensure you get the best deal with minimal
            financial burden. Here are the key aspects to consider when choosing
            a personal loan:
          </p>

          {/* Single Column Layout */}

          {points3.map((item, index) => (
            <div
              key={index}
              className="p-5 mb-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {item.title}
              </h2>
              <ul className="list-disc list-inside text-gray-600 mt-2">
                {item.points.map((point, idx) => (
                  <li key={idx} className="mt-1">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6 p-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PersonalLoanNew;
